import React from "react";

const css = `
.b {
  fill: #b1b4b3;
}
.c {
  fill: #e8edeb;
}
.d {
  fill: #939997;
}
`;

// SVG dimensions from viewBox
const SVG_WIDTH = 468.838867;
const SVG_HEIGHT = 290.654663;

export const SVG_DIMENSIONS = {
  width: SVG_WIDTH,
  height: SVG_HEIGHT
};

const PhilliesQueueZoneSvg = ({ children }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox={`0 0 ${SVG_WIDTH} ${SVG_HEIGHT}`}
      style={{ width: '100%', height: '100%' }}
    >
      <defs>
        <style>{css}</style>
      </defs>
      
      {/* Border/outline */}
      <path className="d" d="M380.079529,136.040894V0H2.775391v160.640869h322.08429v130.013794h140.671387v-154.61377h-85.451538ZM458.031067,283.154602h-125.671387v-130.013733H10.275391V7.5h362.304138v136.040833h85.451538v139.61377Z"/>
      
      {/* Background fill */}
      <polygon className="c" points="372.579529 143.540833 372.579529 7.5 10.275391 7.5 10.275391 78.347717 10.275391 153.140869 332.35968 153.140869 332.35968 283.154602 458.031067 283.154602 458.031067 143.540833 372.579529 143.540833"/>
      
      {/* Detail rectangles */}
      <g>
        <rect x="371.333008" y="13.499878" width="11.5" height="53.563477"/>
        <rect x="457.338867" y="143.388062" width="11.5" height="139.766602"/>
        <rect y="13.499878" width="11.5" height="61.657227"/>
        <rect y="81.270386" width="11.5" height="66.070312"/>
      </g>

      {/* Zone shape and label injected here */}
      {children}
    </svg>
  );
};

export default PhilliesQueueZoneSvg;